import * as React from 'react';

const MessengerIcon = ({fillColor = '#2D2756'}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={15}>
    <path
      fill={fillColor}
      fillRule="evenodd"
      d="M3.08 14.893a.37.37 0 0 1-.37-.35l-.04-1.368a.875.875 0 0 0-.3-.625A7.004 7.004 0 0 1 0 7.225C0 3.11 3.258 0 7.575 0c4.318 0 7.575 3.104 7.575 7.217 0 4.112-3.266 7.224-7.575 7.224a8.332 8.332 0 0 1-2.199-.28.923.923 0 0 0-.593.044l-1.555.656a.392.392 0 0 1-.147.032Zm2.06-1.962a2.08 2.08 0 0 1 .57.075c.612.165 1.243.25 1.876.25a6.579 6.579 0 0 0 4.564-1.719 5.837 5.837 0 0 0 1.81-4.308 5.838 5.838 0 0 0-1.809-4.305 6.888 6.888 0 0 0-9.11 0A5.837 5.837 0 0 0 1.23 7.23a5.816 5.816 0 0 0 1.968 4.449c.372.326.615.775.684 1.264l.36.197.075-.03c.26-.115.54-.176.825-.18H5.14Z"
      clipRule="evenodd"
    />
    <path
      fill={fillColor}
      fillRule="evenodd"
      d="M3.551 9.288a.083.083 0 0 1-.068-.034.075.075 0 0 1 0-.089l2.114-3.349a.818.818 0 0 1 1.13-.251l.053.037L8.466 6.87a.69.69 0 0 0 .833 0l2.283-1.731a.075.075 0 0 1 .045-.014.091.091 0 0 1 .066.034.082.082 0 0 1 0 .095L9.558 8.603a.81.81 0 0 1-.69.38.825.825 0 0 1-.44-.128l-.053-.04-1.677-1.238a.688.688 0 0 0-.83 0L3.585 9.288a.075.075 0 0 1-.035 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export default MessengerIcon;
